import { render, staticRenderFns } from "./ComplaintAffairInfo.vue?vue&type=template&id=475d134b&scoped=true&"
import script from "./ComplaintAffairInfo.vue?vue&type=script&lang=js&"
export * from "./ComplaintAffairInfo.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintAffairInfo.vue?vue&type=style&index=0&id=475d134b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475d134b",
  null
  
)

export default component.exports